var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapCenterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.0516 7.12558C1.63885 6.96507 1.43248 6.88482 1.37223 6.76917C1.32 6.66893 1.31993 6.54951 1.37204 6.4492C1.43216 6.33349 1.63843 6.25299 2.05099 6.09199L13.759 1.52301C14.1314 1.37767 14.3176 1.30501 14.4366 1.34476C14.54 1.37928 14.621 1.46037 14.6556 1.5637C14.6953 1.68269 14.6227 1.8689 14.4773 2.24132L9.90834 13.9493C9.74734 14.3619 9.66684 14.5682 9.55113 14.6283C9.45082 14.6804 9.3314 14.6803 9.23115 14.6281C9.11551 14.5678 9.03525 14.3615 8.87474 13.9487L7.05271 9.26351C7.02013 9.17972 7.00384 9.13783 6.97868 9.10256C6.95637 9.07129 6.92903 9.04395 6.89777 9.02165C6.86249 8.99649 6.8206 8.9802 6.73682 8.94761L2.0516 7.12558Z",
    stroke: "#6C7C8B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapCenterIcon);
export default __webpack_public_path__ + "static/media/map_center_icon.a010952c57efc8c9352d7b0be371e05f.svg";
export { ForwardRef as ReactComponent };